// extracted by mini-css-extract-plugin
export var currencyInput = "_j9-1";
export var currencySymbol = "_j9-0";